import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Mill Lining', path: '/mill-lining' },
  { name: 'Wear Parts', path: '/wear-parts' },
  { name: 'Overlay Systems', path: '/overlay-systems' },
  { name: 'Laser', path: '/laser' },
  { name: 'Precision Turning', path: '/precision-turning' },
  { name: 'Contact', path: '/contact' },
];

const logoMap = {
  '/': 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/nv6apram_Group%2045.svg',
  '/mill-lining': 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/ytbu403v_Mill%20Lining.svg',
  '/wear-parts': 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/fth7cmy8_Wear%20Parts.svg',
  '/overlay-systems': 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/pcdd53pg_Overlay%20Systems.svg',
  '/laser': 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/930rd9zb_Laser.svg',
  '/precision-turning': 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/ebrujhl6_Precision%20Turning.svg',
  '/contact': 'https://customer-assets.emergentagent.com/job_catworth-group/artifacts/nv6apram_Group%2045.svg',
};

export const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  
  const currentLogo = logoMap[location.pathname] || logoMap['/'];

  return (
    <nav 
      className="fixed top-0 w-full bg-white/95 backdrop-blur-sm border-b border-neutral-100 z-50"
      data-testid="navbar"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center"
            data-testid="navbar-logo"
          >
            <img 
              src={currentLogo}
              alt="Catworth Group"
              className="h-12 md:h-14"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-xs font-medium uppercase tracking-widest transition-colors hover:text-black ${
                  location.pathname === link.path 
                    ? 'text-black' 
                    : 'text-neutral-500'
                }`}
                data-testid={`nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-neutral-100 py-6">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium uppercase tracking-widest transition-colors hover:text-black ${
                    location.pathname === link.path 
                      ? 'text-black' 
                      : 'text-neutral-500'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
